import "./DataCircle";

const DataCircle = ({ percentage, from_percentage, size, show_blue, custom_color = null, stroke_width = 5, letter_only = false }) => {
  let randId = 1 + Math.floor(Math.random() * 100000000);
  const uniqueGradientId = `data-circle-linear-gradient-${randId}`;
  let percentageLabel = percentage;
  if (typeof percentage === 'undefined') {
    percentage = 0;
    percentageLabel = '';
  }

  let line =
    from_percentage > percentage
      ? "M7.733 14.667 12 10.4m-4.267 4.267L3.467 10.4m4.266 4.267V1.333"
      : "M7.733 1.333 12 5.6M7.733 1.334 3.467 5.6m4.266-4.266v13.333";

  if (from_percentage === percentage || show_blue === true || custom_color !== null) line = "";
  if (stroke_width === null) stroke_width = 5;

  let percentNumeric;
  if (typeof percentage === 'string') {
    percentNumeric = parseInt(percentage, 10);
  } else {
    percentNumeric = percentage;    
  }

  // Align data circle colors with AA - D rating colors
  let data_circle_colour;
  let letterGrade;
  if (percentNumeric >= 0 && percentNumeric < 30) {
    data_circle_colour = "#DA3547"; // D rating color
    letterGrade = 'D'
  } else if (percentNumeric >= 30 && percentNumeric < 45) {
    data_circle_colour = "#E67C85"; // C rating color
    letterGrade = 'C'
  } else if (percentNumeric >= 45 && percentNumeric < 60) {
    data_circle_colour = "#DB9401"; // B rating color
    letterGrade = 'B'
  } else if (percentNumeric >= 60 && percentNumeric < 75) {
    data_circle_colour = "#81E19D"; // A rating color
    letterGrade = 'A'
  } else if (percentNumeric >= 75) {
    data_circle_colour = "#38CD63"; // AA rating color
    letterGrade = 'AA'
  } else {
    data_circle_colour = "#858590"; // No rating color 
    letterGrade = 'N/A'
  }

  if (show_blue === true) {
    data_circle_colour = "#01B4F9"; //Blue5
  }

  if (custom_color !== null) {
    data_circle_colour = "#" + custom_color; //Custom hex code
  }

  const radius = size / 2 - stroke_width / 2; // Dynamic radius
  const circumference = 2 * Math.PI * radius; // Dynamic circumference
  const strokeDashoffset =
    circumference -
    (percentNumeric / 100) *
      circumference;
  // Dynamic dashoffset

  const padding = stroke_width; // Set padding relative to size
  const innerSize = size - padding * 2; // Inner circle size

  let middleDisplay;
  if (letter_only) {
    middleDisplay = letterGrade;
  } else {
    middleDisplay = `${percentageLabel}`;
  }

  const progressBarStyle = `
    --datacircle-size: ${size}px;
    --datacircle-inner-size: ${innerSize}px;
    --datacircle-padding: ${padding}px;
    --datacircle-progress-color: ${data_circle_colour};
    --datacircle-stroke-dasharray: ${circumference};
    --datacircle-stroke-dashoffset: ${strokeDashoffset};
  `;

  const container = document.createElement("div");
  container.innerHTML = `
      <link href='https://fonts.googleapis.com/css?family=Noto+Sans+Mono' rel='stylesheet' />
      <div class='data-circle-wrapper' style="${progressBarStyle}">
        <div class='data-circle-outer'>
          <div class='data-circle-inner'>
            <div class='data-circle-label'>
              <div class='data-circle-percentage'
                style='${from_percentage === undefined ? "display: flex; align-items: center;" : ""}'
              >${middleDisplay}</div>
              ${
                from_percentage !== undefined && !letter_only
                  ? `
                  <div class='data-circle-from-score'>
                    <div class='data-circle-from-percentage'>${from_percentage}</div>
                    ${
                      line !== ""
                        ? `
                        <div class='data-circle-arrow'>
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" viewBox="0 0 15 15">
                        <path stroke="#858590" stroke-linecap="round" stroke-linejoin="round" d="${line}"/>
                      </svg>
                    </div>
                      `
                        : ``
                    }
                  </div>
                  `
                  : ``
              }
            </div>
          </div>
        </div>  
        
        <svg id="data-circle-svg" width="${size}px" height="${size}px">
          <defs>
            <linearGradient id="${uniqueGradientId}">
              <stop offset="0%" stop-color="${data_circle_colour}" />
              <stop offset="100%" stop-color="${data_circle_colour}" />
            </linearGradient>          
          </defs>
          <circle id="data-circle-points" cx="${size / 2}" cy="${size / 2}" r="${radius}" stroke="url(#${uniqueGradientId})"/>
        </svg>
      </div>
  `;
  return container;
};

export default DataCircle;